"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleTemplate = void 0;
var ScheduleTemplate_component_1 = require("./ScheduleTemplate.component");
Object.defineProperty(exports, "ScheduleTemplate", { enumerable: true, get: function () { return __importDefault(ScheduleTemplate_component_1).default; } });
